import { render, staticRenderFns } from "./dealingWorkList.vue?vue&type=template&id=19649c5c&"
import script from "./dealingWorkList.vue?vue&type=script&lang=js&"
export * from "./dealingWorkList.vue?vue&type=script&lang=js&"
import style0 from "./dealingWorkList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dealingWorkList.vue"
export default component.exports